
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder,FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { SelectablesService } from '../selectables.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { LRFormService } from '../l-r-form.service';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { DataTableDirective } from 'angular-datatables';

import { ConsignorService } from '../_services/_masters/consignor.service';
import { ProductService } from '../_services/_masters/product.service';
import { OnAccountService } from '../_services/_masters/on-account.service';
import { PartyService } from '../_services/_masters/party.service';
import { VehicleService } from '../_services/_masters/vehicle.service';
import { DestinationService } from '../_services/_masters/destination.service';
import { BranchMasterService } from '../_services/_masters/branch-master.service';
import { RRFormService } from '../r-r-form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';

import 'rxjs/add/operator/map';
import swal from 'sweetalert2';

// import * as $ from 'jquery';
declare var $ : any;


const user_info = JSON.parse(localStorage.getItem('currentUser'));
const headers = new Headers({'Content-Type': 'application/json','Authorization': JSON.parse(localStorage.getItem("user_token"))});
const options = new RequestOptions({ headers: headers });


class LRForm {
	lr_date: string;
	lr_number: string;
	consignor: string;
	loading: string;
	station: string;
	LRNumber: string;
	on_account : string;
	party:string;
	truck_number: string;
	owned_by: string;
	sto_number : string;
	freight_rate : string;
	freight_amt : string;
	advance_paid : string;
	balance : string;
	diesel_amt : string;
	product: string;
	weight:string;
	qty_bags:string;
	rr_date : string;
	rr_number: string;
}

@Component({
	selector: 'app-l-r-form',
	templateUrl: './l-r-form.component.html',
	styleUrls: ['./l-r-form.component.css']
})
export class LRFormComponent implements OnInit {

	lRForm : FormGroup;
	check_branch: boolean = true;
	selected_branch_name="";

	stations : string[] = [];
	products : string[] = [];
	consignors: any[] = [];
	godowns: any[] = [];
	onaccount: string[] = [];
	party: string[] = [];
	truckno:string[]=[];
	destination:string[]=[];
	product_package=[];
	rr_number:any[]=[];
	get_product_package:any;

	advance_info_flag : boolean = false;
	lr_saved : boolean = false;
	last_lr_number="";

	//bsConfig: Partial<BsDatepickerConfig>;

	// dtOptions: DataTables.Settings = {};
	dtOptions: any = {};
	lrform: LRForm[] = [];
	modalLRForm :FormGroup;
	modalData:any;
	// We use this trigger because fetching the list of persons can be quite long,
	// thus we ensure the data is fetched before rendering
	dtTrigger: Subject<any> = new Subject();
	message:any;
	selected_rr_num:any;
	loadPoint:any;
	selected_branch:string;
	selected_client:string;
	selected_advance_info:any;
	selected_godown_to :boolean = false;
	url = environment.url;
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;
	lr_date:Date=new Date(Date.now());

	response :any = null ;
	query :any = null ;

	rr_balance_weight : any = null ;
	rr_dispatched_weight : any = null ;

	pipe = new DatePipe('en-US');

	constructor(
		public fb: FormBuilder,
		private lRFormService : LRFormService, 
		private http: Http, 
		private selectablesService : SelectablesService ,
		private selectConsignorService : ConsignorService,
		private selectProductService : ProductService,
		// private selectBranchService : SelectablesService,
		private selectBranchService : BranchMasterService,
		private onAccountService : OnAccountService,
		private partyService : PartyService,
		private VehicleService:VehicleService,
		private DestinationService:DestinationService,
		public RRFormService:RRFormService,
		private spinner: NgxSpinnerService
	) { }
	//loading: string = 'rail';
	
	ngOnInit(){ 
		/** spinner starts on init */
		
		// var myObject = localStorage.getItem('currentUser');
		// var temp = JSON.parse(myObject);	
		// if(localStorage.getItem('currentUser'))
		// {
		// 	if (temp["role"] === 'Admin')
		// 	{
		// 		this.getBranch();
		// 		this.getConsignorBySelectedBranch(null);
		// 		//this.getDestinationBySelectedBranch(null);
		// 		this.check_branch = false;
		// 	}
		// 	else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
		// 	{
		// 		this.lRForm.get('station').setValue(temp['branch']);
		// 		this.stations.push(temp['branch']);
		// 		this.getConsignorBySelectedBranch(temp['branch']);
		// 		//this.getDestinationBySelectedBranch(temp['branch']);
		// 		this.check_branch = true;
		// 	}
		// }

		this.selected_rr_num = this.selectablesService.selected_rr_number;
		this.loadPoint = this.getSelectedLoadingPoint()
		this.selected_branch = this.selectablesService.selected_branch;
		this.selected_client = this.selectablesService.selected_client;
		this.selected_advance_info = this.selectablesService.advance_info;
		if(this.selected_client && this.selected_branch )
		{
			this.selected_branch_name=this.selected_branch;
			this.getLastLRNumber(this.selected_client);
			this.getDestinationBySelectedBranchAndClient(this.selected_client);
		}

		this.lRForm = new FormGroup({
			'rr_number': new FormControl(null, Validators.required),
			'lr_date': new FormControl(null, Validators.required),
			'rr_date': new FormControl(null),
			'station': new FormControl(this.selected_branch, Validators.required),
			'consignor' : new FormControl(this.selected_client, Validators.required),
			'loading' : new FormControl(this.loadPoint, Validators.required),
			'on_account': new FormControl(null, Validators.required),
			'party' : new FormControl(null, Validators.required),
			'destination' : new FormControl(null, Validators.required),
			'truck_number':new FormControl(null, Validators.required),
			'owned_by': new FormControl(null, Validators.required),
			'sto_number' : new FormControl(null),
			'gp_number' : new FormControl(null),
			'freight_rate' : new FormControl(null),
			'freight_amt' : new FormControl(null),
			'advance_paid' : new FormControl(null),
			'balance' : new FormControl(null),
			'diesel_amt' : new FormControl(null),
			'product' : new FormControl(null, Validators.required),
			'weight': new FormControl(null, Validators.required),
			'qty_bags': new FormControl(null, Validators.required),
			'godown': new FormControl(null)
		});

		this.onFreightAmtChanges();

		

		this.modalLRForm = new FormGroup({

			'lr_date': new FormControl(null),
			'lr_number': new FormControl(null),
			'gp_number': new FormControl(null),
			'rr_date': new FormControl(null),
			'station': new FormControl(null, Validators.required),
			'consignor' : new FormControl(null, Validators.required),
			'loading' : new FormControl(null, Validators.required),
			'on_account': new FormControl(null, Validators.required),
			'party' : new FormControl(null, Validators.required),
			'destination' : new FormControl(null, Validators.required),
			'truck_number':new FormControl(null, Validators.required),
			'owned_by': new FormControl(null, Validators.required),
			'sto_number' : new FormControl(null),
			'rr_number' : new FormControl(null),
			'freight_rate' : new FormControl(null),
			'freight_amt' : new FormControl(null),
			'advance_paid' : new FormControl(null),
			'balance' : new FormControl(null),
			'diesel_amt' : new FormControl(null),
			'product' : new FormControl(null, Validators.required),
			'weight': new FormControl(null, Validators.required),
			'qty_bags': new FormControl(null, Validators.required),
			'godown': new FormControl(null)
		});

		var form_info = localStorage.getItem('form_info');
		var form_data = JSON.parse(form_info);
		if (form_info){
			this.lRForm.patchValue({

				'rr_number': form_data.rr_number,
				'gp_number': form_data.gp_number,
				'rr_date': form_data.rr_date,
				'station': form_data.station,
				'consignor' : form_data.consignor,
				'loading' : form_data.loading,
				'on_account': form_data.on_account,
				'party' : form_data.party,
				'destination' : form_data.destination,
				'truck_number': form_data.truck_number,
				'owned_by': form_data.owned_by,
				'sto_number' : form_data.sto_number,
				'godown' : form_data.godown,
				// 'product' : form_data.product,
				// 'weight': form_data.weight,
				// 'qty_bags': form_data.qty_bags
			});
			$("#smallProduct").text(form_data.product);
			$("#smallWeight").text(form_data.weight);
			$("#smallQtyBags").text(parseFloat(form_data.qty_bags).toFixed(2));
		}

		// Call changeLoading method at initial stage
		// this.changeLoading(this.loadPoint);		

		//this.bsConfig = Object.assign({}, { containerClass: 'theme-default' });

		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			ordering : false,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};
		this.http.get(this.url + '/lrform/all', options)
		// this.http.get('http://backendtransport.iogreen.in/lrform/all')
			.map(this.extractData)
			.subscribe(forms => {
				this.lrform = forms;
				console.log(this.lrform);
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
			});
		console.log("Table udpating with RR")
		// if (this.lRForm.get("rr_number").value){
		// 	this.getLRTableByRRNumber(this.lRForm.get("rr_number").value);
		// 	console.log("Table updated with RR")
		// }


		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.check_branch = false;
				console.log("Inside Role checking");
				this.getRRNumber();
				this.getBranch();
				this.getConsignorAndTruckBySelectedBranch(null);
				//this.getDestinationBySelectedBranch(null);
				
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{	
				this.check_branch = true;
				console.log("role non-admin")
				this.lRForm.get('station').setValue(temp['branch']);
				this.stations.push(temp['branch']);
				this.getConsignorAndTruckBySelectedBranch(temp['branch']);
				this.getRRFormWithBranch(temp['branch']);
				//this.getDestinationBySelectedBranch(temp['branch']);
				
			}
		}

		this.getOnAccount();
		this.getParty();
		this.loadAllAutoComplete();
		this.getBalanceRRWeight(this.lRForm.get('rr_number').value)
	} 
	getRRNumber()
	{
		this.rr_number=[];
		this.RRFormService.getAllRRForm()
		.subscribe(
			rr_number => {
				for(var i=0;i<rr_number.length;i++)
				{
					this.rr_number.push(rr_number[i]['rr_number']);
				}
			});
	}
	getRRFormWithBranch(branch)
	{
		this.rr_number=[];
		this.RRFormService.getRRFormWithBranch(branch)
		.subscribe(
			rr_number => {
				for(var i=0;i<rr_number.length;i++)
				{
					this.rr_number.push(rr_number[i]['rr_number']);
				}
			});
	}
	getDestination()
	{
		this.destination=[];
		this.DestinationService.getAllDestination()
		.subscribe(
			destination => {
				console.log(destination);
				for(var i=0;i<destination.length;i++)
				{
					this.destination.push(destination[i]['destination_name']);
				}
			});
	}
	getDestinationBySelectedBranch(branch)
	{
		this.destination=[];
		this.DestinationService.getDestinationFormWithBranch(branch)
		.subscribe(
			destination => {
				console.log(destination);
				for(var i=0;i<destination.length;i++)
				{
					this.destination.push(destination[i]['destination_name']);
				}
			});
	}
	getConsignerAndDestination(branch)
	{
		this.getConsignorBySelectedBranch(branch);
		this.getDestinationBySelectedBranch(branch);
	}
	getOnAccount()
	{
		this.onAccountService.getAllOnAccount()
		.subscribe(
			onaccount => {
				for(var i=0;i<onaccount.length;i++)
				{
					this.onaccount.push(onaccount[i]['account_name']);
				}
			});
	}
	getParty()
	{
		this.partyService.getAllParty()
		.subscribe(
			party => {
				for(var i=0;i<party.length;i++)
				{
					this.party.push(party[i]['party_name']);
				}
			});
	}
	getConsignor()
	{
		this.selectConsignorService.getAllConsignor()
		.subscribe(
			consignors => {
				for(var i=0;i<consignors.length;i++)
				{
					if (this.consignors.includes(consignors[i]['consignor_name'])){

					}
					else{
						this.consignors.push(consignors[i]['consignor_name']);
					}
				}
			});
	}
	getDestinationBySelectedBranchAndClient(client)
	{
		let destination_table_name=this.selected_branch_name+"_"+client+"_destination";
		this.destination=[];
		this.DestinationService.getDestinationFormWithClientAndBranch(destination_table_name)
		.subscribe(
			destination => {;
				console.log(destination);
				for(var i=0;i<destination.length;i++)
				{	
					if (this.destination.includes(destination[i]['destination_name'])){

					}
					else{
						this.destination.push(destination[i]['destination_name']);
					}
					
				}
			});
	}
	getProductAndDestinationByBranchAndClient(client)
	{
		if(client)
		{
			this.getLastLRNumber(client);
			// this.getLRTableBySelectedBranchAndClient(client)
			this.getProductBySelectedClient(client);
			this.getDestinationBySelectedBranchAndClient(client);
			this.getGodownBySelectedClient(client);
		}
	}
	getLRTableByRRNumber(get_rr_number)
	{
		if(get_rr_number)
		{	
			console.log("inside update Table");
			this.getBalanceRRWeight(get_rr_number)
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.destroy();
				this.http.get(this.url + '/lrform/get/byrrnumber/'+get_rr_number, options)
					.map(this.extractData)
					.subscribe(forms => {
						console.log("table by RR")
						console.log(forms)
					this.lrform = forms;
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next();
				});
			});
		}
		
	}
	getLRTableBySelectedBranchAndClient(client)
	{	
		console.log(client)
		if ((typeof client !== 'undefined') && (client)){
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.destroy();
				this.http.get(this.url + '/lrform/get/branchandclient/'+this.selected_branch_name+'/'+client, options)
					.map(this.extractData)
					.subscribe(forms => {
					console.log("table by B n C")
					console.log(forms)
					this.lrform = forms;
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next();
				});
			});
			this.getProductAndDestinationByBranchAndClient(client)
		}
	}

	getLRTableBySelectedBranch(branch)
	{	
		if ((typeof branch !== 'undefined') && (branch)){
			this.selected_branch_name = branch;
			console.log(branch);
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.destroy();
				this.http.get(this.url + '/lrform/get/branch/'+this.selected_branch_name, options)
					.map(this.extractData)
					.subscribe(forms => {
					console.log("table by Branch")
					console.log(forms)
					this.lrform = forms;
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next();
				});
			});
		}
		this.getConsignerAndDestination(branch);
		this.getConsignorAndTruckBySelectedBranch(branch);
		return branch
	}
	getLastLRNumber(client)
	{
		this.last_lr_number="";
		this.lRFormService.getLastLRNumber(client)
		.subscribe(
			lastlrnumber => {
				this.last_lr_number = lastlrnumber.toString();
			});
	}
	getConsignorAndTruckBySelectedBranch(branch)
	{
		this.truckno=[];
		this.getConsignorBySelectedBranch(branch);
		this.VehicleService.getVehicleFormWithBranch(branch)
		.subscribe(
			truckno => {
				for(var i=0;i<truckno.length;i++)
				{
					this.truckno.push(truckno[i]['truck_no']);
				}
			});
		
	}
	getConsignorBySelectedBranch(branch)
	{
		if (branch == null){
			branch=user_info["branch"];
			console.log(user_info["branch"])
		}
		else{
			this.selected_branch_name=branch;
		}
		this.consignors=[];
		this.selectConsignorService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				//alert(consignors);
				
				for(var i=0;i<consignors.length;i++)
				{
					if (this.consignors.includes(consignors[i]['consignor_name'])){

					}
					else{
						this.consignors.push(consignors[i]['consignor_name']);
					}
				}
			});
	}
	getProductBySelectedClient(client)
	{
		this.products=[];
		this.selectProductService.getProductByClientName(client)
		.subscribe(
			products => {
				for(var i=0;i<products.length;i++)
				{
					this.products.push(products[i]['product_name']);
					this.product_package.push(products[i]);
				}
			});
	}

	getGodownBySelectedClient(client)
	{	
		this.godowns=[];
		this.http.get(this.url + "/masters/godown/get/branchandclient/" +this.lRForm.get("station").value + "/" + client, options)
		.subscribe(
			godowns => {
				var godown = godowns.json()
				console.log(godown);
				for(var i=0;i<godown.length;i++)
				{	
					if (this.godowns.includes(godown[i]['godown_name'])){

					}
					else{
						this.godowns.push(godown[i]['godown_name']);
					}
					
				}
			});
	}
	getBranch()
	{
		// this.selectBranchService.getBranches()
		this.http.get(this.url+"/branch/all", options)
		.subscribe(
			branch => {
				console.log(branch.json());
				var branches = branch.json();
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			}
		);
	}
   
	// Set validator as per selecting loading
	changeLoading(loadBy)
	{	
		console.log(loadBy);
		var form_info = localStorage.getItem('form_info');
		var form_data = JSON.parse(form_info);	
		if (loadBy === 'By Rail')
		{	
			this.lRForm.get('rr_number').setValidators([Validators.required]);
			if(form_data) {
				this.lRForm.get('rr_number').setValue(form_data.rr_number);
			} 
			else{
				this.lRForm.get('rr_number').setValue(null);
			}          
			this.lRForm.get('sto_number').setValue(null);
			this.lRForm.get('sto_number').setValidators(null);
			this.lRForm.get('godown').setValue(null);
			this.lRForm.get('godown').setValidators(null);
			this.lRForm.get('rr_number').updateValueAndValidity();
			this.lRForm.get('sto_number').updateValueAndValidity();
			this.lRForm.get('godown').updateValueAndValidity();
			this.getGodownBySelectedClient(this.lRForm.get('consignor').value);
		} 
		else if(loadBy === 'By Godown')  
		{
			// this.lRForm.get('sto_number').setValidators([Validators.required]);            
			this.lRForm.get('godown').setValidators([Validators.required]);            
			this.lRForm.get('rr_number').setValue(null);
			if(form_data){
				this.lRForm.get('godown').setValue(form_data.godown);
			}
			else{
				this.lRForm.get('godown').setValue(null);
			}
			this.lRForm.get('rr_number').setValidators(null);
			// this.lRForm.get('sto_number').updateValueAndValidity();
			this.lRForm.get('godown').updateValueAndValidity();
			this.lRForm.get('rr_number').updateValueAndValidity();
			this.getGodownBySelectedClient(this.lRForm.get('consignor').value);
		}
		console.log(this.lRForm); 
		console.log(this.lRForm.valid);
	}
	getProductQty(product_weight)
	{
		let get_product_qty = product_weight.target.value*1000/this.get_product_package;
		if (!isNaN(get_product_qty))
		{
			this.lRForm.get('qty_bags').setValue(get_product_qty);
			this.modalLRForm.get('qty_bags').setValue(get_product_qty);
		}
		else
		{
			this.lRForm.get('qty_bags').setValue("");
			this.modalLRForm.get('qty_bags').setValue("");
		}
	}
	getProductWeight(product_qty)
	{
		let get_product_weight = product_qty.target.value*this.get_product_package/1000;
		if (!isNaN(get_product_weight))
		{
			this.lRForm.get('weight').setValue(get_product_weight);
			this.modalLRForm.get('weight').setValue(get_product_weight);
		}
		else
		{
			this.lRForm.get('weight').setValue("");
			this.modalLRForm.get('weight').setValue("");
		}
	}

	getProductPacking(product_name)
	{
		if(product_name)
		{
			this.get_product_package = this.product_package.find( x => x.product_name == product_name).packing;
		}
		if(this.lRForm.get('destination').value && this.lRForm.get("owned_by").value == "By Self"){
			this.getLRFreightRate();
		}
	}

	onSubmit(){
		console.log(this.lRForm);
	}
	advanceInfoFunc(){
		this.advance_info_flag = true
	}
	calculateFreightAmt(){
		var freight_amt = 0;
		freight_amt = (this.lRForm.get('freight_rate').value * this.lRForm.get('weight').value)
		this.lRForm.patchValue({
			"freight_amt" : freight_amt,
			"advance_paid" : 0,
			"diesel_amt" : 0,
			"balance" : freight_amt.toFixed(2)
		});
		
		if (this.lRForm.get('advance_paid').value || this.lRForm.get('diesel_amt').value ){
			console.log("value hai")
		}
		
	};
	calculateFreightAmtForModal(){
		var freight_amt = 0;
		freight_amt = (this.modalLRForm.get('freight_rate').value * this.modalLRForm.get('weight').value)
		this.modalLRForm.patchValue({
			"freight_amt" : freight_amt
		});
	};

	lRSave(){ 
		//this.lRForm.get('station').enable();
		this.spinner.show();

		this.lr_saved = true; 
		console.log(this.lRForm); 
		console.log(this.lRForm.valid);
		var new_lr_date = new Date(this.lRForm.get("lr_date").value)
		var formatted_lr_date = this.pipe.transform(new_lr_date, 'yyyy-MM-dd'); 
		console.log(formatted_lr_date)
		var lr_form_value = this.lRForm.value;
		lr_form_value["lr_date"] = formatted_lr_date
		this.lRFormService.addNewLR(JSON.stringify(lr_form_value))
		.subscribe(response => {
			console.log(response);
			if(response['status'])
			{
				//this.lRForm.get('station').disable();
				
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.http.get(this.url + '/lrform/all',options)
						.map(this.extractData)
						.subscribe(forms => {
						this.lrform = forms;
						console.log(this.lrform);
						// Calling the DT trigger to manually render the table
						this.dtTrigger.next();
					});
				});
				console.log (this.lrform[0].lr_number )
				this.getBalanceRRWeight(this.lRForm.get("rr_number").value);
				this.spinner.hide();
				window.open(this.url + "/lrform/test/print/" + ( response['lr_number'] ), "_blank");
			}
			else
			{
				setTimeout(() => {
					/** spinner ends after 5 seconds */
					this.spinner.hide();
					swal('LR Generation Failed!', response["message"], 'error');
				}, 1000);
				
			}
		});
		console.log(this.lRForm.value);
	}

	private extractData(res: Response) {
			console.log(res);
			console.log(res.text());
			const body = res.json();
			console.log(body.data || {});
			return body;

		}


	someClickHandler(info: any): void {
		this.lRFormService.getLRFormWith(info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			// console.log(this.modalData[0].basic_info.product);
			this.modalLRForm.patchValue({
				"consignor": this.modalData[0].consignor,
				"loading": this.modalData[0].loading,
				"station": this.modalData[0].station,
				'product': this.modalData[0].product,
				"sto_number": this.modalData[0].sto_number,
				"lr_number": this.modalData[0].lr_number,
				"lr_date": this.modalData[0].lr_date,
				'on_account': this.modalData[0].on_account,
				'party' : this.modalData[0].party,
				'destination' : this.modalData[0].destination,
				'truck_number': this.modalData[0].truck_number,
				'owned_by': this.modalData[0].owned_by,
				'freight_rate' : this.modalData[0].freight_rate,
				'freight_amt' : this.modalData[0].freight_amt,
				'advance_paid' : this.modalData[0].advance_paid,
				'balance' : this.modalData[0].balance,
				'diesel_amt' : this.modalData[0].diesel_amt,
				'rr_date' : this.modalData[0].rr_date,
				'rr_number' : this.modalData[0].rr_number,
				'gp_number' : this.modalData[0].gp_number,
				'weight': this.modalData[0].weight,
				'qty_bags':this.modalData[0].qty_bags,
				'godown':this.modalData[0].godown

			});
		});	
		$("#default-modal").modal('show');
	};

	getSelectedLoadingPoint(){
		var point = this.selectablesService.selected_loading_point;
		console.log("getSeletecLoading-LR: " + point);
		if (point == 'rail' || point == 'By Rail'){
			return "By Rail";
		}
		else if(point == 'godown' || point == 'By Godown') {
			return "By Godown";
		}

		else{
			return "By Rail"
		}
	};

	updateLR(){
		console.log(this.modalLRForm.value);
		this.http.post( this.url + "/lrform/update", this.modalLRForm.value, options)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response);
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'LR Updated Successfully'){
					swal(
						' Success',
						'LR Form Updated Successfully',
						'success'
					);
				}

				if (this.response.message === 'LR Information not Changed'){
					swal(
						' Info ',
						'LR information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					' Acknowledge Failed',
					'Please enter a LR number',
					'error'
				);
			}
			
		});
	};

	printModalLR(){
		window.open(this.url + "/lrform/test/print/" +  this.modalLRForm.get('lr_number').value , "_blank");
	};

	reset()
	{
		this.lRForm.reset();
	}

	getLRFreightRate(){
		console.log("Value Changes for destiantion");
		if (this.lRForm.get('owned_by').value == "By Self"){
			this.query = {
				"branch" : this.lRForm.get("station").value,
				"consignor" : this.lRForm.get("consignor").value,
				"destination_name" : this.lRForm.get("destination").value
			}
			console.log(this.query);
			this.http.post( this.url + "/lr/freight/for", this.query, options)
			.subscribe(res=>{
				console.log(res.json());
				this.response = res.json();
				if(this.response["rate_for_destination"] != 0 ){
					this.lRForm.patchValue({
						"freight_rate" : this.response.rate_for_destination,
						"freight_amt" : (this.response.rate_for_destination * this.lRForm.get('weight').value),
						"advance_paid" : 0,
						"diesel_amt" : 0,
						"balance" : (this.response.rate_for_destination * this.lRForm.get('weight').value).toFixed(2)
					});
				}
				else if(this.response["rate_for_destination"] == 0){
					swal(
						'No Freight Rate Found!',
						'Please update the Freight Rate sheet or Enter rate manually.',
						'warning'
					);
					this.lRForm.patchValue({
						"freight_rate" : 0,
						"freight_amt" : 0
					});
				}
				
			})
		}
		else{
			this.lRForm.patchValue({
				"freight_amt" : (this.lRForm.get('freight_rate').value * this.lRForm.get('weight').value)
			})
		}
	}
	getLRFreightRateForModal(){
		console.log("Value Changes for destiantion");
		if (this.modalLRForm.get('owned_by').value == "By Self"){
			this.query = {
				"branch" : this.modalLRForm.get("station").value,
				"consignor" : this.modalLRForm.get("consignor").value,
				"destination_name" : this.modalLRForm.get("destination").value
			}
			console.log(this.query);
			this.http.post( this.url + "/lr/freight/for", this.query, options)
			.subscribe(res=>{
				console.log(res.json());
				this.response = res.json();
				if(this.response["rate_for_destination"] != 0 ){
					this.lRForm.patchValue({
						"freight_rate" : this.response.rate_for_destination,
						"freight_amt" : (this.response.rate_for_destination * this.modalLRForm.get('weight').value)
					});
				}
				else if(this.response["rate_for_destination"] == 0){
					swal(
						'No Freight Rate Found!',
						'Please update the Freight Rate sheet or Enter rate manually.',
						'warning'
					);
					this.modalLRForm.patchValue({
						"freight_rate" : 0,
						"freight_amt" : 0
					});
				}
			})
		}
		else{
			this.modalLRForm.patchValue({
				"freight_amt" : (this.modalLRForm.get('freight_rate').value * this.modalLRForm.get('weight').value)
			})
		}
	}
	setBalance(get_pait_amount)
	{
		console.log(this.lRForm.get('diesel_amt').value);
		console.log(get_pait_amount.target.value);
		let total_amount = parseFloat(this.lRForm.get('freight_amt').value );
		let advance_amt = ((get_pait_amount.target.value == null || get_pait_amount.target.value == "") ? 0 : get_pait_amount.target.value);
		let diesel_amt = ((this.lRForm.get('diesel_amt').value == null || this.lRForm.get('diesel_amt').value == "" ) ? 0 :this.lRForm.get('diesel_amt').value );
		let balance = total_amount - (parseFloat(advance_amt) + parseFloat(diesel_amt));
		this.lRForm.get('balance').setValue(balance.toFixed(2));
	}

	setBalanceForModal(get_pait_amount)
	{
		console.log(this.modalLRForm.get('diesel_amt').value);
		console.log(get_pait_amount.target.value);
		let total_amount = parseFloat(this.modalLRForm.get('freight_amt').value );
		let advance_amt = ((get_pait_amount.target.value == null || get_pait_amount.target.value == "") ? 0 : get_pait_amount.target.value);
		let diesel_amt = ((this.modalLRForm.get('diesel_amt').value == null || this.modalLRForm.get('diesel_amt').value == "" ) ? 0 :this.modalLRForm.get('diesel_amt').value );
		let balance = total_amount - (parseFloat(advance_amt) + parseFloat(diesel_amt));
		this.modalLRForm.get('balance').setValue(balance.toFixed(2));
	}

	deductDieselAmount(diesel_amt){	
		let total_amount = this.lRForm.get('freight_amt').value;
		let diesel_amt_paid = ((diesel_amt.target.value == null || diesel_amt.target.value == "" ) ? 0 :diesel_amt.target.value );
		let advance_amt = ((this.lRForm.get('advance_paid').value == null || this.lRForm.get('advance_paid').value == "") ? 0 : this.lRForm.get('advance_paid').value);
		let balance = total_amount - (parseFloat(diesel_amt_paid ) + parseFloat(advance_amt));
		this.lRForm.get('balance').setValue(balance.toFixed(2));
	};

	calculateBalance(){
		console.log(this.lRForm.get('freight_amt').value);
		let total_amount = this.lRForm.get('freight_amt').value;
		let diesel_amt = ((this.lRForm.get('diesel_amt').value == null || this.lRForm.get('diesel_amt').value == "" ) ? 0 :this.lRForm.get('diesel_amt').value );
		let advance_amt = ((this.lRForm.get('advance_paid').value == null || this.lRForm.get('advance_paid').value == "") ? 0 : this.lRForm.get('advance_paid').value);
		let balance = total_amount - (parseFloat(diesel_amt) + parseFloat(advance_amt));
		this.lRForm.get('balance').setValue(balance.toFixed(2));
	};

	deductDieselAmountForModal(diesel_amt){	
		let total_amount = this.modalLRForm.get('freight_amt').value;
		let diesel_amt_paid = ((diesel_amt.target.value == null || diesel_amt.target.value == "" ) ? 0 :diesel_amt.target.value );
		let advance_amt = ((this.modalLRForm.get('advance_paid').value == null || this.modalLRForm.get('advance_paid').value == "") ? 0 : this.modalLRForm.get('advance_paid').value);
		let balance = total_amount - (parseFloat(diesel_amt_paid ) + parseFloat(advance_amt));
		this.modalLRForm.get('balance').setValue(balance.toFixed(2));
	};

	calculateBalanceForModal(){
		console.log(this.modalLRForm.get('freight_amt').value);
		let total_amount = this.modalLRForm.get('freight_amt').value;
		let diesel_amt = ((this.modalLRForm.get('diesel_amt').value == null || this.modalLRForm.get('diesel_amt').value == "" ) ? 0 :this.modalLRForm.get('diesel_amt').value );
		let advance_amt = ((this.modalLRForm.get('advance_paid').value == null || this.modalLRForm.get('advance_paid').value == "") ? 0 : this.modalLRForm.get('advance_paid').value);
		let balance = total_amount - (parseFloat(diesel_amt) + parseFloat(advance_amt));
		this.modalLRForm.get('balance').setValue(balance.toFixed(2));
	};

	deleteLR(){
		console.log(this.modalLRForm.value);
		this.http.post( this.url + "/lrform/check/delete", this.modalLRForm.value, options)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			if (this.response["status"]) {
				swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!'
				}).then((result) => {
					if (result.value) {
						this.http.post( this.url + "/lrform/delete", {"lr_number" :this.modalLRForm.get('lr_number').value}, options)
						.subscribe(res => {
							console.log(res.json());
							var feedback = res.json();
							if (feedback.status){
								$("#default-modal").modal('hide');
								swal(
									'Deleted!',
									'Your LR has been deleted.',
									'success'
								);
								this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
									dtInstance.destroy();
									this.http.get(this.url + '/lrform/all', options)
										.map(this.extractData)
										.subscribe(forms => {
										this.lrform = forms;
										console.log(this.lrform);
										// Calling the DT trigger to manually render the table
										this.dtTrigger.next();
									});
								})
								this.getLRFreightRate();
							}
						});
					}
				})
			}
			else{
				if (this.response.message = "LR is Present in Invoice"){
					swal(
						'Failed!',
						'This LR number is used for invoice receipts.',
						'error'
					)
				}
			}

		});
	};

	loadAllAutoComplete(){
		this.getConsignorAndTruckBySelectedBranch(this.lRForm.get('station').value);
		this.getProductAndDestinationByBranchAndClient(this.lRForm.get('consignor').value);
		console.log(this.product_package);
		this.changeLoading(this.lRForm.get('loading').value);
		this.getLRFreightRate();
		// this.getLRTableByRRNumber(this.lRForm.get("rr_number").value);
		console.log(this.lRForm.get('product').value);
		this.http.get(this.url + "/masters/product/get/branchandclient/" + this.lRForm.get('station').value + "/" + this.lRForm.get('consignor').value, options)
		.subscribe( res => {
			console.log(res.json());
			var product_info = res.json()
			this.product_package.push(product_info);
			this.get_product_package = product_info.packing
			console.log(this.product_package);
			console.log(this.get_product_package);
		});

		this.getProductPacking(this.lRForm.get('product').value);
		// this.getProductQty(this.lRForm.get('weight').value)


	}


	getBalanceRRWeight(rr_number){
		if((this.lRForm.get("loading").value == "By Rail") && (this.lRForm.get("rr_number").value != null)){
			this.http.get(this.url + '/rrform/get/' + rr_number, options)
			.subscribe( res =>{
				this.response = res.json();
				console.log(this.response);
				this.rr_balance_weight = Number(this.response[0]["lr_rr_weight"]).toFixed(2);
				this.rr_dispatched_weight = (Number(this.response[0]["rr_weight"]) - this.rr_balance_weight).toFixed(2);
				console.log(this.rr_balance_weight);
				console.log(this.rr_dispatched_weight);
			});
		}
		else{
			this.rr_balance_weight = 0;
			this.rr_dispatched_weight = 0;
			console.log(this.rr_balance_weight);
			console.log(this.rr_dispatched_weight);
		}
	};

	onFreightAmtChanges(){
		this.lRForm.get('freight_amt').valueChanges.subscribe(val =>{
			console.log("Freight amt value changds");

		});
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/l-r-form/l-r-form.component.ts